






































import ThgQuoteExportDialog from "@/components/thg/ThgQuoteExportDialog.vue";
import TheLayoutPortalList from "@/layouts/TheLayoutPortalList.vue";
import { BillingTypeEnum } from "@/lib/enum/billingType.enum";
import { CheckEnum } from "@/lib/enum/check.enum";
import { CountryCodeEnum } from "@/lib/enum/country-code.enum";
import { $t } from "@/lib/utility/t";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import PaginationListMixin from "@/mixins/PaginationListMixin.vue";
import { PageFilterElement } from "@/models/page-filter-element.entity";
import { ThgBillingViewmodelGen } from "@/services/thg/v1/data-contracts";
import { BillingModule } from "@/store/modules/billing.store";
import { PredefinedFilterType } from "@/views/event/filter/event.filter";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import ThgBillingCreateNewDialog from "./ThgBillingCreateNewDialog.vue";
import ThgBillingPlausibilityCheckDialog from "./ThgBillingPlausibilityCheckDialog.vue";

@Component({
  components: {
    ThgQuoteExportDialog,
    ThgBillingPlausibilityCheckDialog,
    ThgBillingCreateNewDialog,
    TheLayoutPortalList
  }
})
export default class ThgBillingList extends mixins(DarkModeHighlightMixin, PaginationListMixin) {
  get CheckEnum() {
    return CheckEnum;
  }

  get predefinedFilter(): PredefinedFilterType[] {
    return [
      {
        name: $t("views.ThgBillingBatchView.reverseChargeProcedure"),
        filter: [
          new PageFilterElement({
            key: "pdfBilling.input.isTaxDeductible",
            value: (true as any) as string // FIXME
          }),
          new PageFilterElement({
            key: "pdfBilling.input.countryCode",
            value: CountryCodeEnum.austria
          })
        ]
      }
    ];
  }

  getBillingTypeText(billingType: BillingTypeEnum) {
    return this.$t("components.thg.thgBillingCreateNewBillingManual")[billingType] || billingType;
  }

  getModule() {
    return BillingModule;
  }

  isActive(item: ThgBillingViewmodelGen) {
    return item.billingNumber === BillingModule.createdBilling.billingNumber ? this.color : "";
  }
}
